<template>
  <transition appear>
    <div
      class="step-box"
      :class="{'step-box--valid': currentStep > step}"
    >
      <div
        class="step-box__step"
        :class="{'step-box__step--valid': currentStep > step || valid}"
      >{{ step }}</div>
      <div class="step-box__title">
        {{ title }}
        <span
          v-if="subText"
          class="step-box__sub-text"
        >{{ subText }}</span>
      </div>
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "StepBox",
  props: {
    // 何ステップ目のコンポーネントか
    step: {
      type: Number,
      default: 0
    },
    // タイトル
    title: {
      type: String,
      default: ''
    },
    // サブテキスト
    subText: {
      type: String,
      default: ''
    },
    // 現在のステップ数
    currentStep: {
      type: Number,
      default: 0
    },
    // このフォームが valid なら true
    valid: {
      type: Boolean,
      default: false
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.step-box {
  padding: 3px 0 35px 36px;
  position: relative;
  &::before {
    opacity: 0;
    content: '';
    position: absolute;
    top: 28px;
    bottom: 100%;
    left: 12px;
    display: block;
    width: 2px;
    background: linear-gradient(90.45deg, #CB8BFF 16.67%, #FF7497 82.29%);
    transition: 0.2s;
  }
  &--valid::before {
    opacity: 1;
    bottom: 2px;
  }
  &__step {
    font-family: din-2014, sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.6;
    text-align: center;
    color: $col_gray2;
    position: absolute;
    top: 0;
    left: 0;
    width: 26px;
    height: 26px;
    border: 2px solid #DCDFE2;
    border-radius: 100%;
    &--valid {
      color: $col_white;
      border-color: transparent;
      background: linear-gradient(135deg, #FF7497 18.23%, #CB8BFF 80.21%);
      background-origin: border-box;
    }
  }
  &__title {
    font-weight: bold;
    font-size: 18px;
    line-height: 1.2;
    margin: 0 0 15px;
  }
  &__sub-text {
    display: inline-block;
    font-size: 11px;
    font-weight: normal;
  }
}
.v-enter-active, .v-leave-active {
  transition: opacity 1s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/StepBox.vue